import React, { useState } from 'react';
import { deleteBox } from '../api';

function localDateKey() {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
}

function formatReminderDate(value) {
  const dateKey = String(value || '').slice(0, 10);
  if (!dateKey) return '';
  return new Intl.DateTimeFormat('de-DE').format(new Date(`${dateKey}T12:00:00`));
}

export default function BoxKarte({ box, isSubBox, parentNumber, onEdit, onDeleted, onPrint }) {
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [deleting, setDeleting] = useState(false);

  async function handleDelete() {
    setDeleting(true);
    try {
      await deleteBox(box.id);
      onDeleted(box.id);
    } catch (err) {
      alert('Fehler beim Loeschen: ' + err.message);
      setDeleting(false);
      setConfirmDelete(false);
    }
  }

  const fotos = box.fotos || [];
  const isPrepared = !box.parent_box && !box.kategorie && !box.inhalt_stichworte &&
    !box.standort && !box.erinnerung_am && !box.erinnerung_text && fotos.length === 0;
  const reminderDate = String(box.erinnerung_am || '').slice(0, 10);
  const reminderDue = reminderDate && reminderDate <= localDateKey();
  return (
    <article className={`box-card${isSubBox ? ' box-card-sub' : ''}${isPrepared ? ' box-card-prepared' : ''}`}>
      <div className="box-card-topline">
        <div>
          {isSubBox && <div className="box-card-parent">Unterbox von {parentNumber || box.parent_box}</div>}
          <div className="box-card-number">{box.box_nummer}</div>
        </div>
        {box.standort && (
          <div className="box-card-location">
            <span className="box-card-location-label">Platz</span>
            <strong>{box.standort}</strong>
          </div>
        )}
      </div>

      <div className="box-card-badges">
        {isPrepared && <span className="box-badge box-badge-prepared">Vorbereitet</span>}
        {box.kategorie && <span className="box-badge">{box.kategorie}</span>}
      </div>

      <div className={`box-card-body${fotos.length > 0 ? '' : ' box-card-body-no-photo'}`}>
        <div className="box-card-content">
          {box.inhalt_stichworte ? (
            <p>{box.inhalt_stichworte}</p>
          ) : (
            <p className="box-card-empty-text">Noch kein Inhalt dokumentiert</p>
          )}
        </div>

        {fotos.length > 0 && (
          <div className="box-card-photos">
            {fotos.slice(0, 4).map((foto, i) => (
              <div key={foto.id} className="box-card-photo-wrap">
                <img src={foto.url} alt={`Inhalt von ${box.box_nummer}, Foto ${i + 1}`} className="box-card-photo" />
                {i === 3 && fotos.length > 4 && (
                  <div className="box-card-photo-more">+{fotos.length - 4}</div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      {reminderDate && (
        <div className={`box-card-reminder${reminderDue ? ' box-card-reminder-due' : ''}`}>
          <div className="box-card-reminder-topline">
            <span>{reminderDue ? 'Erinnerung fällig' : 'Erinnerung'}</span>
            <strong>{formatReminderDate(reminderDate)}</strong>
          </div>
          {box.erinnerung_text && <p>{box.erinnerung_text}</p>}
        </div>
      )}

      <div className="box-card-footer">
        <button className="box-card-edit" onClick={() => onEdit(box)}>Box öffnen</button>
        <button className="box-card-label" onClick={() => onPrint(box)} aria-label={`Etikett für ${box.box_nummer} drucken`}>Etikett</button>
        {!confirmDelete ? (
          <button className="box-card-delete" onClick={() => setConfirmDelete(true)}>Löschen</button>
        ) : (
          <div className="box-card-confirm">
            <span>Wirklich löschen?</span>
            <button className="box-card-confirm-delete" onClick={handleDelete} disabled={deleting}>
              {deleting ? '…' : 'Ja'}
            </button>
            <button className="box-card-confirm-cancel" onClick={() => setConfirmDelete(false)}>Nein</button>
          </div>
        )}
      </div>
    </article>
  );
}
